import { Button } from "@/src/components/Button";
import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { FC } from "react";
import {TextUsStages, ThankYouStages} from "@/src/shared/const";

const CONTENT = {
    [TextUsStages.ThankYouWorkDays]: { description: "Будь ласка, очікуйте на зворотній зв'язок від менеджера інтернет-магазину найближчим часом для надання консультації."},
    [TextUsStages.ThankYouWeekend]: { description: "Для надання консультації ми обов’язково зв’яжемося з Вами в найближчі робочі години."},
} as Record<ThankYouStages, { description: string}>;

interface ThankYouStageProps {
    type: ThankYouStages,
    onAccept: () => void;
}

export const ThankYouStage: FC<ThankYouStageProps> = ({ type, onAccept }) => {
    return (
        <Stack
            className={
                "flex max-w-[524px] flex-col items-center gap-4 rounded-xl bg-white p-6 center-modal max-md:bottom-modal max-md:animate-up-modal"
            }
        >
            <Box className={"h-20 w-20 p-6 bg-super-light-blue rounded-full"}>
                <Image
                    src={"/images/text-us-thank-you.svg"}
                    alt={"admin"}
                    width={80}
                    height={80}
                    quality={60}
                />
            </Box>
            <Typography variant={"body1"} className={"mt-2 text-lg font-semibold"} component={"h5"}>
                {"Дякуємо за ваше звернення!"}
            </Typography>
            <Typography component={"p"} className={"text-center"}>
                {CONTENT[type].description}
            </Typography>
            <Button onClick={onAccept}>{"Гаразд"}</Button>
        </Stack>
    );
};
